'use strict'

module.exports = (function () {
    /**
    * @ngdoc method
    * @name fixedNavObserver
    * @description Initializes an observer that monitors the height of the fixed navs.
    *   the height info is stored in namespaced global variable window.getours.fixedNavData
    *   and can be retrieved via getHeightData()
    * 
    *   NOTE:
    *   One of the limitations of the fixedNavObserver is that it is actually watching for resize
    *   This means that if an element switches from being "position: relative"" to "position: fixed",
    *   but its actual height remains the same, it won't fire this thing off.
    **/

    var ResizeObserver = require('resize-observer-polyfill');

    // all fixed navs to be monitored
    window.getours.fixedNavData = [
        {
            selector: '.header-and-nav-wrapper',
            isFixed: function () {
                return document.body.classList.contains('has-fix-strip');
            },
            height: 0
        }, {
            selector: '.topStrip',
            isFixed: function () {
                return hasFixedStyle('.topStrip');
            },
            height: 0
        }, {
            selector: '#variants-and-jumps',
            isFixed: function () {
                return document.body.classList.contains('has-fixed-seasons-strip');
            },
            height: 0
        }, {
            selector: '#vacation-section-years',
            isFixed: function () {
                return document.body.classList.contains('has-fixed-year-select');
            },
            height: 0
        },
        {
            selector: ".submenu-jump-links-section",
            isFixed: function () {
                return document.body.classList.contains('has-submenu-jump-links-section');
            },
            height: 0
        }
    ]

    var getFixedElementHeight = function (selector, isFixed) {
        if (!isFixed) {
            return 0;
        }

        var $el = $(selector);
        return $el.css('display') !== 'none' ? $el.outerHeight() : 0; // jquery may inconsistently return height of hidden elements. Be careful about this
    }

    // Needs only be initialized once per page
    var initializeObserver = function () {
        var resizeObserver = new ResizeObserver(function (entries, obs) {
            window.getours.fixedNavData.forEach(function (navDef) {
                navDef.height = getFixedElementHeight(navDef.selector, navDef.isFixed());
            });

            let totalFixedNavHeight = getTotalFixedNavHeight();
            let event = new CustomEvent('fixed-nav-resize-observed', { detail: totalFixedNavHeight });
            document.dispatchEvent(event);
        });

        // observe heights of all fixed navs
        window.getours.fixedNavData.forEach(function (navDef) {
            var navEl = document.querySelector(navDef.selector);
            if (navEl) {
                resizeObserver.observe(navEl, { box: 'border-box' });
            }
        });
    };

    var getHeightData = function () {
        return window.getours.fixedNavData;
    };

    var getHeightDataBySelector = function (selector) {
        return _.findWhere(window.getours.fixedNavData, { selector: selector });
    }

    var getTotalFixedNavHeight = function () {
        return _.reduce(window.getours.fixedNavData, function (memo, navDef) {
            return memo += navDef.height;
        }, 0);
    }

    var hasFixedStyle = function (selector) {
        var el = document.querySelector(selector);
        if (el) {
            var elStyles = window.getComputedStyle(el);
            var computedPosition = elStyles.getPropertyValue('position');
            var computedDisplay = elStyles.getPropertyValue('display');
            if (computedPosition === 'fixed' && computedDisplay !== 'none') {
                return true;
            }
        }

        return false;
    }

    // Return an object exposing the public items
    return {
        initialize: initializeObserver,
        getHeights: getHeightData,
        getHeightBySelector: getHeightDataBySelector,
        getTotalFixedNavHeight: getTotalFixedNavHeight
    };
}())